/**
 * File post-archive.js.
*
* Handles load-more functionality and post category filtering.
*
* @package wildrivers
*/

import { WPRest } from './wprest';

export function categoryFilter() {
	const categoryFilter = document.getElementById( 'category-filter' );

	// Return early if the navigation doesn't exist.
	if ( ! categoryFilter ) {
		return;
	}

	const button = categoryFilter.getElementsByTagName( 'button' )[ 0 ];

	// Return early if the button doesn't exist.
	if ( 'undefined' === typeof button ) {
		return;
	}

	const menu = categoryFilter.getElementsByTagName( 'ul' )[ 0 ];

	// Hide menu toggle button if menu is empty and return early.
	if ( 'undefined' === typeof menu ) {
		button.style.display = 'none';
		return;
	}

	// Toggle the .toggled class and the aria-expanded value each time the button is clicked.
	button.addEventListener( 'click', function () {
		categoryFilter.classList.toggle( 'toggled' );
		menu.style.left = button.offsetLeft + 'px';

		if ( button.getAttribute( 'aria-expanded' ) === 'true' ) {
			button.setAttribute( 'aria-expanded', 'false' );
		} else {
			button.setAttribute( 'aria-expanded', 'true' );
		}
	} );

	// Remove the .toggled class and set aria-expanded to false when the user clicks outside the navigation.
	document.addEventListener( 'click', function ( event ) {
		const isClickInside = categoryFilter.contains( event.target );

		if ( ! isClickInside ) {
			categoryFilter.classList.remove( 'toggled' );
			button.setAttribute( 'aria-expanded', 'false' );
		}
	} );
}

export function loadMore() {

	function htmlDecode(input) {
		var doc = new DOMParser().parseFromString(input, "text/html");
		return doc.documentElement.textContent;
	}

	// article wrapper.
	const articles = document.querySelector( '.excerpts-container' );
	
	// Return early if the articles section doesn't exist.
	if ( ! articles ) {
		return;
	}

	// Load more section.
	const loadMore = document.getElementById( 'archive_load_more' );

	// Return early if the load more section doesn't exist.
	if ( ! loadMore ) {
		return;
	}

	// Button in loadmore.
	const button = loadMore.getElementsByTagName( 'button' )[ 0 ];

	// Return early if the button doesn't exist.
	if ( 'undefined' === typeof button ) {
		return;
	}

	const category = loadMore.dataset.category;
	const perPage  = loadMore.dataset.perPage;

	// initial check if there is more content.
	let page     = loadMore.dataset.page;
	let request  = '/wp-json/wp/v2/posts?per_page=' + perPage + '&page=' + page;

	const isSearch  = document.querySelector('.search-page-search-form .search-field');
	if ( isSearch ) {
		request = '/wp-json/wp/v2/search?search=' + isSearch.value + '&per_page=' + perPage + 'page=' + page;
	}

	// GET request.
	WPRest.get( request )
		.then( result => loadMore.dataset.hasMore = true )
		.catch( err=>loadMore.dataset.hasMore = false );


	// Subsequent checks for more content.
	button.addEventListener( 'click', function(event) {

		page    = loadMore.dataset.page;
		request = '/wp-json/wp/v2/posts?per_page=' + perPage + '&page=' + page;
		
		if ( isSearch ) {
			request = '/wp-json/wp/v2/search?search=' + isSearch.value + '&per_page=' + perPage + 'page=' + page;
		}

		if ( '0' !== category ) {
			request += '&category=' + category;
		}

		request += '&_embed';

		// GET request.
		WPRest.get( request )
			.then( result => {
				if ( result ) {
					result.forEach( (post) => {

						let postClass = [
							'post-excerpt',
							'post',
							'type-post',
							'status-publish',
							'format-standard',
							'hentry',
							'post-' + post.id,
						];

						const art = document.createElement("article");
						art.classList.add( ...postClass );

						const anchor = document.createElement("a");
						anchor.href  = post.link;
						anchor.rel   = "bookmark";
						anchor.classList.add( 'excerpt-link' );
						art.appendChild(anchor);

						const content = document.createElement("div");
						content.classList.add('post-excerpt--content');

						const header = document.createElement("header");
						header.classList.add('entry-header');

						const h3 = document.createElement('h3');
						h3.classList.add( 'entry-title', 'has-heading-h-4-font-size' );
						h3.innerText = htmlDecode( post.title.rendered );
						header.appendChild(h3);

						const postedOn = document.createElement('span');
						postedOn.classList.add( 'posted-on', 'has-small-font-size', 'is-italic' );

						const time = document.createElement('time');
						time.classList.add('entry-date');
						time.datetime = post.date_gmt;

						let dateTime = new Date(post.date);
						let month    = dateTime.getMonth();
						let day      = dateTime.getDate();
						let year     = dateTime.getFullYear();

						if ( month.toString.length === 1 ) {
							month = '0' + month;
						}
						if ( day.toString.length === 1 ) {
							day = '0' + day;
						}
						time.innerText = month + '/' + day + '/' + year;

						postedOn.appendChild(time);

						header.appendChild(postedOn);

						content.appendChild(header);


						const entry = document.createElement("div");
						entry.classList.add('entry-content');
						entry.innerHTML = post.excerpt.rendered;

						content.appendChild(entry);

						art.appendChild(content);

						if ( post.featured_media ) {
							art.classList.add( 'has-featured-image', 'has-post-thumbnail' );
							
							const imgDiv = document.createElement("div");
							imgDiv.classList.add('post-excerpt--image');
							
							const postImage  = document.createElement("img");
							postImage.src    = post._embedded['wp:featuredmedia']['0'].media_details.sizes.medium.source_url;
							postImage.width  = post._embedded['wp:featuredmedia']['0'].media_details.sizes.medium.width;
							postImage.height = post._embedded['wp:featuredmedia']['0'].media_details.sizes.medium.height;
							postImage.alt    = post._embedded['wp:featuredmedia']['0'].alt_text;
							postImage.classList.add( 'attachment-medium', 'size-medium', 'wp-post-image' );

							imgDiv.appendChild(postImage);
							art.appendChild(imgDiv);
						}

						articles.appendChild(art);
					});

					if ( result.length < perPage ) {
						loadMore.dataset.hasMore = false;
					} else {
						loadMore.dataset.page = parseInt(page) + 1;
					}
				}
			} )
			.catch( err=>loadMore.dataset.hasMore = false );

	} );
}

